import { render, staticRenderFns } from "./CardProductPluginPc.vue?vue&type=template&id=13f8140f&scoped=true"
import script from "./CardProductPluginPc.vue?vue&type=script&lang=js"
export * from "./CardProductPluginPc.vue?vue&type=script&lang=js"
import style0 from "./CardProductPluginPc.vue?vue&type=style&index=0&id=13f8140f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8140f",
  null
  
)

export default component.exports